import { motion } from 'framer-motion';
import { FiCalendar, FiMapPin, FiBriefcase } from 'react-icons/fi';

const Experience = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          My <span className="bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">Experience</span>
        </h2>
        
        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-blue-500 to-purple-500"></div>
          
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative pl-20 pb-12"
          >
            {/* Timeline dot */}
            <div className="absolute left-6 top-6 w-4 h-4 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full border-4 border-gray-900"></div>
            
            <div className="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50 hover:border-blue-500/30 transition-all">
              <div className="flex flex-wrap items-center gap-4 mb-4">
                <div className="flex items-center text-blue-400">
                  <FiBriefcase className="mr-2" />
                  <span className="font-semibold">React Native Developer</span>
                </div>
                <div className="flex items-center text-gray-400">
                  <FiCalendar className="mr-2" />
                  <span>3 Years</span>
                </div>
                <div className="flex items-center text-gray-400">
                  <FiMapPin className="mr-2" />
                  <span>Jaipur, India</span>
                </div>
              </div>
              
              <h3 className="text-xl font-bold mb-2 text-white">
                Truworth Health Technologies Pvt Ltd
              </h3>
              
              <div className="space-y-3 text-gray-300">
                <p className="leading-relaxed">
                  Currently working as a React Native Developer with 3 years of experience in mobile app development 
                  and cross-platform solutions.
                </p>
                
                <div className="space-y-2">
                  <h4 className="font-semibold text-blue-400">Key Responsibilities:</h4>
                  <ul className="space-y-2 ml-4">
                    <li className="flex items-start">
                      <span className="text-blue-400 mr-2 mt-1">•</span>
                      <span>Maintaining and enhancing "The Wellness Corner" application</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-400 mr-2 mt-1">•</span>
                      <span>Creating reusable NPM packages and modules for both mobile app and web platforms</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-400 mr-2 mt-1">•</span>
                      <span>Debugging and fixing application issues to ensure optimal performance</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-400 mr-2 mt-1">•</span>
                      <span>Developing cross-platform mobile solutions using React Native</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-400 mr-2 mt-1">•</span>
                      <span>Collaborating with teams to deliver high-quality healthcare technology solutions</span>
                    </li>
                  </ul>
                </div>
                
                <div className="flex flex-wrap gap-2 mt-4">
                  {['React Native', 'JavaScript', 'TypeScript', 'NPM Packages', 'Mobile Development', 'Cross-platform', 'Healthcare Tech'].map((skill) => (
                    <span
                      key={skill}
                      className="px-3 py-1 bg-blue-500/10 text-blue-300 text-sm rounded-full border border-blue-500/20"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
        
        <div className="text-center mt-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-500/10 to-purple-500/10 border border-blue-500/20 rounded-lg"
          >
            <span className="text-blue-400 font-medium">
              Looking for new opportunities and challenges
            </span>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default Experience;
